<script>
// import apiServices from '@/services/yungol-services'
export default {
  template: `
    <div style='width: 100%; height: 100%; margin: auto;'>
      <div v-if='!buttons' class="has-text-centered">
              <span class="icon" style="padding-top: 20px;">
                <span v-tooltip.right="{content: messageR, targetClasses: 'tag is-warning', html: true}">No cumple</span>
              </span>
      </div>
      <div v-if='buttons' class="buttons is-justify-end">
        <router-link
        v-tooltip="'Ver resultados del Líder'"
        :to="{ name: 'resultlider', params: { procesoid: params.data.proceso, liderid: params.data.evaluado._id } }"
        class="button is-dark"
        target="_blank"
        style='margin-top: 5px;'
        >
          <span class="icon">
            <i class="material-icons">visibility</i>
          </span>
        </router-link>
        <button style='margin-top: 5px;' class="button is-link" v-tooltip="'Copiar link de resultados'" v-on:click="copyLink()">
            <span class="icon">
              <i class="material-icons">share</i>
            </span>
        </button>
      </div>
    </div>`,
  data(){
    return {
      params: this.$parent.params,
      buttons: true,
      messageR: "Es necesario al menos la autoevaluación para mostrar resultados",
    }
  },
  beforeMount() {
    if (this.params.data.status !== 'calculado' && this.params.data['cantEncuestasCalculate'] < 3){
      this.buttons = false
    }
  },
  methods:{
    // Actions
    copyLink(){
      const i = this.params.data
      const url = window.location.host + '/sharelider/' + i._id + '/' + i.evaluado._id + '/' + i.proceso

      const textArea = document.createElement('textarea')
      textArea.style.position = 'fixed'
      textArea.style.top = 0
      textArea.style.left = 0
      textArea.style.width = '2em'
      textArea.style.height = '2em'
      textArea.style.padding = 0
      textArea.style.border = 'none'
      textArea.style.outline = 'none'
      textArea.style.boxShadow = 'none'
      textArea.style.background = 'transparent'
      textArea.value = url

      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        const successful = document.execCommand('copy')
        this.$store.dispatch('notify', {
          message: successful ? '¡Copiado al portapapeles!' : 'Error al copiar',
          type: successful ? 'is-link' : 'is-danger'
        })
      } catch (err) {
        console.log(err)
      }

      document.body.removeChild(textArea)
    }
  }
}
</script>

<style lang='scss'>
.no-border {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/components/buttonsActionSummary.vue